import { render, staticRenderFns } from "./DNAReport.vue?vue&type=template&id=32af2174&scoped=true&"
import script from "./DNAReport.vue?vue&type=script&lang=js&"
export * from "./DNAReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32af2174",
  null
  
)

export default component.exports